import { cn } from "@/utils/utils"
import * as RadixAccordion from "@radix-ui/react-accordion"
import { ComponentPropsWithoutRef } from "react"

// Exactly what Radix's Accordion.Root accepts (the discriminated single | multiple union,
// incl. className/children/div attrs). Passthrough wrapper that only adds a full-width default.
type AccordionProps = ComponentPropsWithoutRef<typeof RadixAccordion.Root>

export const Accordion = ({ className, ...props }: AccordionProps) => (
  <RadixAccordion.Root className={cn("w-full", className)} {...props} />
)
